import React, { Component } from 'react'
import  {Modal, Dropdown} from 'react-bootstrap'
import { ModalHover } from 'react-modal-hover'
  import styles from '../../Css/OverlayModal.module.css'
 
export default class OverlayModal extends Component {
    constructor(props){
        super(props)
        this.state={
        }

    }

    

    render() {
         
        return (
                <Modal 
                        Fades={{backFadeIn:".5s linear", contFadeIn:".5s linear"}}
                        show={this.props.overlayPopupHandlar}
                        dialogClassName="modal-90w"
                        aria-labelledby="example-custom-modal-styling-title"
                        size='md'
                        centered
                        // onClick = {this.props.handleOverlayPopup}
                        onMouseMove = {this.props.handleOverlayPopup}
                        // className={styles['hide-in-mobile']}
                    >
                        <Modal.Header />
                        
                                <Modal.Body>
                                    <div className={[styles['overlay-modal'],'row'].join(' ')}>
                                       <img src={this.props.image}/>                                       
                                    </div>
                                </Modal.Body>

                         
                </Modal>
        )
    }
}
